import { mapNotificationFilterData } from '../../ui/features/inbox';
export function getNotificationBulkActionParams(dataTableProps, appliedFilterData, staticFilterData) {
    var _a;
    const selectedNotificationIds = (_a = dataTableProps.selectedRowIds) !== null && _a !== void 0 ? _a : [];
    return {
        queryParams: selectedNotificationIds.length > 0
            ? undefined
            : mapNotificationFilterData(Object.assign(Object.assign({}, appliedFilterData), staticFilterData), {
                orderBy: dataTableProps.sortColumnKey,
                orderDirection: dataTableProps.sortColumnDesc ? 'desc' : 'asc',
            }),
        notificationIds: selectedNotificationIds.length > 0 ? selectedNotificationIds : undefined,
    };
}
